import { isValid } from 'date-fns';
import matter from 'gray-matter';

import parseDate from 'utils/parse-date';

import { SummaryEntry } from './types';

const summariesContext = require.context('./content', true, /summary\.md$/);

export const summaries: SummaryEntry[] = summariesContext.keys().map((path) => {
    const content = summariesContext(path) as string;
    const { data, content: md } = matter(content);

    const id = path.split('/').slice(-2, -1)[0];

    return {
        id,
        title: data.title ?? '',
        date: isValid(data.date) ? parseDate(data.date).toISOString() : '',
        tags: data.tags ?? [],
        shortContent: md
    };
});
